import React, { useState } from 'react';
import {
  Paper,
  TextField,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box,
  Autocomplete,
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DateTimePicker } from '@mui/x-date-pickers';

const IrrigationEntry = () => {
  const [formData, setFormData] = useState({
    farmer: null,
    crop: '',
    startTime: new Date(),
    endTime: null,
    duration: '',
    status: 'draft',
  });

  const farmers = [
    { id: 1, name: 'John Doe', phone: '1234567890' },
    { id: 2, name: 'Jane Smith', phone: '9876543210' },
  ];

  const commonCrops = [
    'Wheat',
    'Rice',
    'Cotton',
    'Sugarcane',
    'Corn',
    'Other'
  ];

  const durationOptions = [
    { value: 1, label: '1 Hour' },
    { value: 2, label: '2 Hours' },
    { value: 3, label: '3 Hours' },
    { value: 4, label: '4 Hours' },
    { value: 5, label: '5 Hours' },
    { value: 6, label: '6 Hours' },
  ];

  const handleInputChange = (field, value) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const handleDurationChange = (event) => {
    const duration = event.target.value;
    const startTime = formData.startTime;
    const endTime = new Date(startTime.getTime() + (duration * 60 * 60 * 1000));
    
    setFormData({
      ...formData,
      duration,
      endTime,
    });
  };

  const handleSubmit = (isDraft = true) => {
    const irrigationData = {
      ...formData,
      status: isDraft ? 'draft' : 'completed',
    };
    console.log('Saving irrigation data:', irrigationData);
    // Here you would typically save to your backend
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Paper sx={{ p: 3, maxWidth: 800, margin: 'auto' }}>
        <Typography variant="h5" gutterBottom>
          New Irrigation Entry
        </Typography>
        
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Autocomplete
              options={farmers}
              getOptionLabel={(option) => `${option.name} (${option.phone})`}
              value={formData.farmer}
              onChange={(event, newValue) => handleInputChange('farmer', newValue)}
              renderInput={(params) => (
                <TextField {...params} label="Select Farmer" required />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>Crop</InputLabel>
              <Select
                value={formData.crop}
                label="Crop"
                onChange={(e) => handleInputChange('crop', e.target.value)}
              >
                {commonCrops.map((crop) => (
                  <MenuItem key={crop} value={crop}>{crop}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {formData.crop === 'Other' && (
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Specify Crop"
                value={formData.otherCrop}
                onChange={(e) => handleInputChange('otherCrop', e.target.value)}
              />
            </Grid>
          )}

          <Grid item xs={12} sm={6}>
            <DateTimePicker
              label="Start Time"
              value={formData.startTime}
              onChange={(newValue) => handleInputChange('startTime', newValue)}
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>Duration</InputLabel>
              <Select
                value={formData.duration}
                label="Duration"
                onChange={handleDurationChange}
              >
                {durationOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {formData.endTime && (
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="End Time"
                value={formData.endTime.toLocaleString()}
                InputProps={{ readOnly: true }}
              />
            </Grid>
          )}
        </Grid>

        <Box sx={{ mt: 3, display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
          <Button
            variant="outlined"
            onClick={() => handleSubmit(true)}
          >
            Save as Draft
          </Button>
          <Button
            variant="contained"
            onClick={() => handleSubmit(false)}
          >
            Complete Entry
          </Button>
        </Box>
      </Paper>
    </LocalizationProvider>
  );
};

export default IrrigationEntry;
